const SvgForStatisticReports = (): JSX.Element => {
  const compStyles = getComputedStyle(document.documentElement);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50"
      height="100"
      fill="#fff"
      stroke="#fff"
      strokeWidth="0.005"
      version="1.1"
      viewBox="-163.84 -163.84 839.68 839.68"
      xmlSpace="preserve"
    >
      <path
        fill={compStyles.getPropertyValue("--statistic-color")}
        opacity={"0.8"}
        strokeWidth="0"
        d="M317.192-146.522a118.08 118.08 0 00-122.384 0L-80.712 20.47A118.08 118.08 0 00-137.6 121.44V390.56A118.08 118.08 0 00-80.712 491.53l275.52 166.992a118.08 118.08 0 00122.384 0l275.52-166.992A118.08 118.08 0 00649.6 390.56V121.44A118.08 118.08 0 00592.712 20.47l-275.52-166.992z"
      ></path>
      <g>
        <path d="M128.257 392.533h-.085c-4.71 0-8.491 3.823-8.491 8.533s3.866 8.533 8.576 8.533 8.533-3.823 8.533-8.533-3.823-8.533-8.533-8.533zM179.457 392.533h-.085c-4.71 0-8.491 3.823-8.491 8.533s3.866 8.533 8.576 8.533 8.533-3.823 8.533-8.533-3.823-8.533-8.533-8.533zM247.468 273.067h-68.267c-4.719 0-8.533 3.823-8.533 8.533s3.814 8.533 8.533 8.533h68.267c4.719 0 8.533-3.823 8.533-8.533s-3.814-8.533-8.533-8.533zM213.334 324.267h-34.133a8.53 8.53 0 00-8.533 8.533 8.53 8.53 0 008.533 8.533h34.133a8.53 8.53 0 008.533-8.533 8.53 8.53 0 00-8.533-8.533zM358.401 298.667c-9.412 0-17.067-7.654-17.067-17.067 0-4.71-3.814-8.533-8.533-8.533s-8.533 3.823-8.533 8.533c0 15.855 10.914 29.107 25.6 32.922v1.212a8.53 8.53 0 008.533 8.533 8.53 8.53 0 008.533-8.533v-1.212c14.686-3.814 25.6-17.067 25.6-32.922 0-18.825-15.309-34.133-34.133-34.133-9.412 0-17.067-7.654-17.067-17.067 0-9.412 7.654-17.067 17.067-17.067 9.412 0 17.067 7.654 17.067 17.067 0 4.71 3.814 8.533 8.533 8.533s8.533-3.823 8.533-8.533c0-15.855-10.914-29.107-25.6-32.922v-1.212a8.53 8.53 0 00-8.533-8.533 8.53 8.53 0 00-8.533 8.533v1.212c-14.686 3.814-25.6 17.067-25.6 32.922 0 18.825 15.309 34.133 34.133 34.133 9.412 0 17.067 7.654 17.067 17.067 0 9.412-7.655 17.067-17.067 17.067zM333.057 392.533h-.085c-4.71 0-8.491 3.823-8.491 8.533s3.866 8.533 8.576 8.533c4.71 0 8.533-3.823 8.533-8.533s-3.822-8.533-8.533-8.533zM435.457 409.6c4.71 0 8.533-3.823 8.533-8.533s-3.823-8.533-8.533-8.533h-.085c-4.71 0-8.491 3.823-8.491 8.533s3.866 8.533 8.576 8.533zM384.257 392.533h-.085c-4.71 0-8.491 3.823-8.491 8.533s3.866 8.533 8.576 8.533c4.71 0 8.533-3.823 8.533-8.533s-3.822-8.533-8.533-8.533zM349.868 102.4h34.133a8.53 8.53 0 008.533-8.533 8.53 8.53 0 00-8.533-8.533h-34.133a8.53 8.53 0 00-8.533 8.533 8.53 8.53 0 008.533 8.533zM230.657 392.533h-.085c-4.71 0-8.491 3.823-8.491 8.533s3.866 8.533 8.576 8.533 8.533-3.823 8.533-8.533-3.823-8.533-8.533-8.533zM128.001 290.133h17.067c4.719 0 8.533-3.823 8.533-8.533s-3.814-8.533-8.533-8.533h-17.067c-4.719 0-8.533 3.823-8.533 8.533s3.814 8.533 8.533 8.533zM128.001 341.333h17.067a8.53 8.53 0 008.533-8.533 8.53 8.53 0 00-8.533-8.533h-17.067a8.53 8.53 0 00-8.533 8.533 8.53 8.53 0 008.533 8.533z"></path>
        <path d="M469.334 0H42.668a8.53 8.53 0 00-8.533 8.533v494.933a8.536 8.536 0 005.265 7.885 8.535 8.535 0 009.301-1.852l45.167-45.167 45.167 45.167a8.523 8.523 0 0012.066 0l28.1-28.1 28.1 28.1a8.523 8.523 0 0012.066 0l28.1-28.1 11.034 11.034a8.525 8.525 0 0012.066 0l28.1-28.1 28.1 28.1a8.525 8.525 0 0012.066 0l19.567-19.567 19.567 19.567a8.525 8.525 0 0012.066 0l45.167-45.167 28.1 28.1c.171.179.35.341.538.495 0 .009.008.009.008.009v.009a8.54 8.54 0 005.112 1.98c.316.009.631.009.964-.009h.009a8.515 8.515 0 005.853-2.935 8.523 8.523 0 002.082-5.564V8.533A8.528 8.528 0 00469.334 0zm-8.533 448.734l-19.567-19.567a8.525 8.525 0 00-12.066 0l-45.167 45.167-19.567-19.567a8.523 8.523 0 00-12.066 0l-19.567 19.567-28.1-28.1a8.523 8.523 0 00-12.066 0l-28.1 28.1-11.034-11.034a8.523 8.523 0 00-12.066 0l-28.1 28.1-28.1-28.1a8.51 8.51 0 00-6.033-2.5 8.509 8.509 0 00-6.033 2.5l-28.1 28.1-45.167-45.167a8.523 8.523 0 00-12.066 0l-36.634 36.634v-465.8h409.6v431.667z"></path>
        <path d="M77.057 409.6c4.71 0 8.533-3.823 8.533-8.533s-3.823-8.533-8.533-8.533h-.085c-4.71 0-8.491 3.823-8.491 8.533s3.866 8.533 8.576 8.533zM128.001 238.933h17.067c4.719 0 8.533-3.823 8.533-8.533s-3.814-8.533-8.533-8.533h-17.067c-4.719 0-8.533 3.823-8.533 8.533s3.814 8.533 8.533 8.533zM281.857 409.6c4.71 0 8.533-3.823 8.533-8.533s-3.823-8.533-8.533-8.533h-.085c-4.71 0-8.491 3.823-8.491 8.533s3.866 8.533 8.576 8.533zM179.201 187.733h51.2c4.719 0 8.533-3.823 8.533-8.533s-3.814-8.533-8.533-8.533h-51.2c-4.719 0-8.533 3.823-8.533 8.533s3.814 8.533 8.533 8.533zM128.001 187.733h17.067c4.719 0 8.533-3.823 8.533-8.533s-3.814-8.533-8.533-8.533h-17.067c-4.719 0-8.533 3.823-8.533 8.533s3.814 8.533 8.533 8.533zM264.534 221.867h-85.333c-4.719 0-8.533 3.823-8.533 8.533s3.814 8.533 8.533 8.533h85.333c4.719 0 8.533-3.823 8.533-8.533s-3.814-8.533-8.533-8.533zM128.001 102.4h136.533a8.53 8.53 0 008.533-8.533 8.53 8.53 0 00-8.533-8.533H128.001a8.53 8.53 0 00-8.533 8.533 8.53 8.53 0 008.533 8.533z"></path>
      </g>
    </svg>
  );
};
const SvgForNullReports = (): JSX.Element => {
  const compStyles = getComputedStyle(document.documentElement);
  return (
    <svg
      id="Icons"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-14.4 -14.4 60.80 60.80"
      xmlSpace="preserve"
      width="50px"
      height="100px"
      fill="#dddd"
    >
      <rect
        x={-14.4}
        y={-14.4}
        width={60.8}
        height={60.8}
        rx={30.4}
        fill={compStyles.getPropertyValue("--zero-color")}
        id="SVGRepo_bgCarrier"
        strokeWidth={0}
      />
      <g id="SVGRepo_iconCarrier">
        <style>
          {
            ".st0,.st1{fill:none;stroke:#fff;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10}.st1{stroke-linecap:round}"
          }
        </style>
        <circle className="st0" cx={22} cy={22} r={7} />
        <path className="st0" d="M29 22L22 22 22 15" />
        <path className="st0" d="M28 14V5H4v23c2.1-1.8 4.5-3.2 7-4.2" />
        <path className="st1" d="M11 12L17 12" />
        <path className="st1" d="M11 16L14 16" />
      </g>
    </svg>
  );
};
const SvgForKickbackReports = (): JSX.Element => {
  const compStyles = getComputedStyle(document.documentElement);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50"
      height="100"
      fill="#fff"
      version="1.1"
      viewBox="-51.2 -51.2 614.4 614.4"
      xmlSpace="preserve"
    >
      <g>
        <path
          fill={compStyles.getPropertyValue("--kickback-color")}
          d="M256 .032L0 246.768h91.472v265.2H432.24v-265.2H512L256 .032z"
        ></path>
        <g fill="#FFF">
          <path d="M246.64 407.328v-48.72c-15.2-4.336-26.336-10.912-33.424-19.696s-10.64-19.488-10.64-32.048c0-12.704 4.016-23.392 12.032-32.032s18.688-13.632 32.032-14.944v-11.52h16.864v11.52c12.336 1.472 22.128 5.664 29.424 12.608 7.28 6.944 11.936 16.24 13.952 27.856l-29.424 3.824c-1.776-9.136-6.432-15.344-13.952-18.592v45.456c18.608 5.04 31.28 11.584 38.032 19.6 6.736 8.032 10.112 18.32 10.112 30.88 0 14.032-4.256 25.856-12.736 35.472s-20.288 15.504-35.408 17.664V456.4H246.64v-21.168c-13.408-1.632-24.304-6.624-32.672-15.008-8.368-8.368-13.712-20.192-16.048-35.472l30.336-3.248c1.248 6.208 3.568 11.552 6.976 16.048 3.424 4.512 7.216 7.76 11.408 9.776zm0-122.096c-4.576 1.568-8.224 4.192-10.928 7.904s-4.064 7.824-4.064 12.336c0 4.112 1.248 7.92 3.712 11.456 2.48 3.536 6.24 6.368 11.28 8.544v-40.24zm16.848 123.712c5.808-1.072 10.528-3.776 14.192-8.08 3.648-4.304 5.472-9.36 5.472-15.168 0-5.184-1.536-9.664-4.592-13.44-3.056-3.744-8.08-6.64-15.056-8.656v45.344h-.016zM145.28 175.152L256 68.432l110.72 106.72H145.28z"></path>
        </g>
      </g>
    </svg>
  );
};
const SvgForExportView = (): JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50px"
      height="25px"
      fill="rgb(143, 169, 186)"
      version="1.1"
      viewBox="0 0 367 367"
      xmlSpace="preserve"
    >
      <g>
        <path d="M363.598 247.01c.146-.177.272-.365.409-.547.157-.209.319-.414.464-.632.145-.216.27-.441.402-.662.118-.198.243-.392.352-.596.121-.225.223-.458.332-.688.101-.213.207-.423.298-.643.092-.223.167-.451.248-.678.085-.235.175-.467.248-.708.068-.226.118-.454.176-.683.062-.246.131-.49.181-.741.052-.261.082-.524.12-.788.032-.221.074-.439.096-.664.048-.485.073-.973.074-1.46l.001-.02-.001-.025c0-.486-.025-.971-.073-1.455-.022-.225-.064-.442-.096-.664-.038-.263-.068-.526-.12-.787-.05-.253-.12-.499-.182-.747-.057-.226-.107-.453-.174-.677-.073-.242-.164-.476-.25-.713-.081-.225-.155-.452-.246-.673-.092-.221-.199-.432-.3-.647-.108-.229-.209-.459-.329-.683-.11-.206-.236-.401-.355-.6-.131-.221-.256-.443-.4-.658-.147-.219-.31-.424-.467-.635-.136-.182-.262-.368-.407-.544a14.95 14.95 0 00-.948-1.049c-.016-.016-.029-.034-.045-.05l-37.499-37.501c-5.857-5.857-15.355-5.858-21.213-.001-5.858 5.858-5.858 15.355 0 21.213l11.894 11.895-45.788.002v-78.605c.003-.133.02-.263.02-.396a14.92 14.92 0 00-3.407-9.49l-.064-.079a15.166 15.166 0 00-1.002-1.091c-.132-.131-.255-.272-.393-.398L155.609 22.896a14.985 14.985 0 00-.97-.882c-.104-.087-.212-.169-.318-.253a14.853 14.853 0 00-1.914-1.293c-.112-.063-.22-.132-.334-.193a14.657 14.657 0 00-1.109-.534c-.154-.067-.311-.124-.467-.186a14.539 14.539 0 00-2.158-.668c-.131-.029-.259-.066-.392-.093-.42-.084-.844-.146-1.27-.193-.13-.015-.262-.023-.393-.035a15.014 15.014 0 00-1.06-.054c-.076-.002-.148-.012-.224-.012H15c-8.284 0-15 6.716-15 15v300c0 8.284 6.716 15 15 15h240c8.284 0 15-6.716 15-15v-80.999l45.786.001-11.893 11.893c-5.858 5.858-5.858 15.355 0 21.213 2.929 2.929 6.768 4.394 10.606 4.394s7.678-1.464 10.606-4.394l37.499-37.499.021-.023c.343-.344.667-.703.973-1.076zM160 69.713l58.787 58.787H160V69.713zM240 318.5H30v-270h100v95c0 8.284 6.716 15 15 15h95v64.001l-65.001-.001c-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15l65.001.001V318.5z"></path>
      </g>
    </svg>
  );
};
interface ErrorIconProps{
  width?:number;
  height?:number;
  fill?:string;
  onClick?:() => void;
}
const CorruptFile = ({width,height,fill,onClick}:ErrorIconProps):JSX.Element => {
  return(
  <svg  width={width ?? 30} height={height ?? 30} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path
      id="SVGRepo_iconCarrier"
      stroke={fill ?? "#000"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="m10 13 4 4m0-4-4 4m3-14H8.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C5 4.52 5 5.08 5 6.2v11.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C6.52 21 7.08 21 8.2 21h7.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C19 19.48 19 18.92 19 17.8V9m-6-6 6 6m-6-6v4.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C13.76 9 14.04 9 14.6 9H19"
    ></path>
  </svg>
  )
}
const WarningTriangle = ({width,height,fill,onClick}:ErrorIconProps):JSX.Element => {
  return(
    <svg width={width ?? 30} height={height ?? 30} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <g id="SVGRepo_iconCarrier">
      <g id="Warning / Triangle_Warning">
        <path
          id="Vector"
          stroke={fill ?? "#000"}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M12 9v4m-7.621 2.2c-.91 1.575-1.364 2.363-1.296 3.01a2 2 0 0 0 .813 1.408C4.422 20 5.331 20 7.15 20h9.703c1.817 0 2.726 0 3.251-.382a2 2 0 0 0 .814-1.409c.068-.646-.386-1.434-1.296-3.01l-4.85-8.4c-.909-1.574-1.364-2.362-1.958-2.626a2 2 0 0 0-1.627 0c-.593.264-1.048 1.052-1.957 2.625zm7.672.8v.1h-.1V16z"
        ></path>
      </g>
    </g>
  </svg>
  )
}
const CircleCross = ({width,height,fill,onClick}:ErrorIconProps) =>{
  return(
     <svg width={width ?? 30} height={height ?? 30} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 -0.5 25 25">
    <g id="SVGRepo_iconCarrier">
      <path
        fillRule="evenodd"
        stroke={fill ?? "#000"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M5.5 12a7 7 0 1 1 14 .001 7 7 0 0 1-14 0"
        clipRule="evenodd"
      ></path>
      <path
        stroke={fill ?? "#000"}
        d="M9.345 14.094a.75.75 0 0 0 1.06 1.06zm3.685-1.563a.75.75 0 1 0-1.06-1.061zm-1.06-1.061a.75.75 0 0 0 1.06 1.06zm3.685-1.566a.75.75 0 0 0-1.061-1.06zM13.03 11.47a.75.75 0 0 0-1.06 1.06zm1.565 3.685a.75.75 0 0 0 1.06-1.061zM11.97 12.53a.75.75 0 0 0 1.06-1.06zm-1.565-3.686a.75.75 0 1 0-1.06 1.06zm0 6.31 2.625-2.623-1.06-1.061-2.625 2.624zm2.626-2.624 2.624-2.626-1.061-1.06-2.624 2.626zm-1.061 0 2.625 2.625 1.06-1.061-2.625-2.624zm1.06-1.06-2.625-2.626-1.06 1.06 2.625 2.626z"
      ></path>
    </g>
  </svg>
  )
}
const CircleExclamation = ({width,height,fill,onClick}:ErrorIconProps) => {
  return(
    <svg width={width ?? 30} height={height ?? 30} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path
      id="SVGRepo_iconCarrier"
      stroke={fill ?? "#000"}
      strokeLinecap="round"
      strokeWidth="2"
      d="M12 8v5m0 3h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    ></path>
  </svg>
  )
}
const Success = ({width,height,fill,onClick}:ErrorIconProps) => {
  return(
    <svg width={width ?? 30} height={height ?? 30} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <g id="SVGRepo_iconCarrier">
      <g
        id="Page-1"
        fill="none"
        fillRule="evenodd"
        stroke={fill ?? "#000"}
        strokeWidth="1"
      >
        <g id="add-copy" stroke={fill ?? "#000"} transform="translate(42.667 42.667)">
          <path
            id="Shape"
            d="M213.333 0C95.513 0 0 95.513 0 213.333s95.513 213.334 213.333 213.334 213.334-95.513 213.334-213.334C426.667 95.513 331.154 0 213.333 0m0 384c-94.105 0-170.666-76.561-170.666-170.667s76.56-170.666 170.666-170.666S384 119.227 384 213.333 307.439 384 213.333 384m80.336-246.886 30.167 30.167L192 299.67l-79.083-79.083 30.166-30.167L192 239.336z"
          ></path>
        </g>
      </g>
    </g>
  </svg>
  )
}
const DownloadArrow = ({width,height,fill,onClick}:ErrorIconProps) => {
  return(
    <svg
    width={width ?? 30} height={height ?? 30}
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    fill={fill ?? "#000"}
    data-name="Layer 1"
    viewBox="0 0 512 512"
  >
    <path
      id="SVGRepo_iconCarrier"
      d="M256 409.7 152.05 305.75l21.45-21.45 67.33 67.32V34h30.34v317.62l67.33-67.32 21.5 21.45ZM445.92 351v93.22a3.61 3.61 0 0 1-3.47 3.48H69.15a3.3 3.3 0 0 1-3.07-3.48V351H35.74v93.22A33.66 33.66 0 0 0 69.15 478h373.3a33.85 33.85 0 0 0 33.81-33.82V351Z"
    ></path>
  </svg>
  )
}
const LoadCircle = ({width,height,fill,onClick}:ErrorIconProps) => {
  return(
     <svg
     width={width ?? 30} height={height ?? 30}
    xmlns="http://www.w3.org/2000/svg"
    className="si-glyph si-glyph-circle-load-right"
    viewBox="0 0 17 17"
  >
    <g id="SVGRepo_iconCarrier">
      <path
        fill={fill ?? "#000"}
        fillRule="evenodd"
        d="M.04 7.379C.115 3.257 3.392-.033 7.344.042c3.917.073 6.854 2.929 6.83 7.003h1.545a.57.57 0 0 1 0 .799L13.873 9.86a.546.546 0 0 1-.785 0l-1.725-2.016a.57.57 0 0 1 0-.799h1.422c.023-3.338-2.259-5.584-5.467-5.644-3.233-.062-5.912 2.63-5.975 6.002-.062 3.322 2.445 6.077 5.613 6.216v1.361C3.059 14.842-.035 11.46.04 7.379"
        className="si-glyph-fill"
      ></path>
    </g>
  </svg>
  )
}
export {
  SvgForStatisticReports,
  SvgForNullReports,
  SvgForKickbackReports,
  SvgForExportView,
  CorruptFile,
  WarningTriangle,
  CircleCross,
  CircleExclamation,
  Success,
  DownloadArrow,
  LoadCircle
};
